import React from 'react'
import AppSidebar from '../../../components/AppSidebar'
import AppHeader from '../../../components/AppHeader'
import PageHeader from '../../../components/PageHeader'
import { toast, ToastContainer } from 'react-toastify'
import { useForm } from 'react-hook-form'
import ConfigurationService from '../../../services/ConfigurationsServices';

const CreateFeedbackSettings = () => {
    const { register, handleSubmit, formState: { errors }, reset } = useForm();

    const onSubmit = async(data) => {
        try {
            const valuesArray = Object.entries(data).map(([key, value]) => ({
                name: key,
                value: value,
              }));
            data.type = "feedback-settings";
            data.value = valuesArray;
            const response = await ConfigurationService.createConfiguration({data});
            if (response.status === 201) {
                toast.success(response?.data?.message);
                reset();
            }
        } catch (error) {
          toast.error(error?.response?.data?.message|| error?.message || "An error occurred");
        }
    }
    return (
        <>
            <AppSidebar />
            <div className="main-content">
                <AppHeader />
                <div className="container-fluid">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <PageHeader title="Feedback Settings" button_label1="Back"
                            link_to1="/feedback-settings" className1="btn btn-primary btn-sm me-2"/>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="FeedbackSettingsPane"
                                    role="tabpanel"
                                    aria-labelledby="FeedbackSettingsTab"
                                >
                                    <div className="card">
                                        {/* <div className="card-header">
                                            <div className="card-title">
                                                <div className="row align-items-end">
                                                    <div className="col">
                                                        <h2 className="header-title">Create Feedback Link</h2>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="card-body">
                                            <form onSubmit={handleSubmit(onSubmit)}>
                                                <div className="row g-3">
                                                    <div className="col-12">
                                                        <label className="form-label">Social Media Platform</label>
                                                        <input type="text" 
                                                            {...register("name", { required: "Name is required" })} 
                                                            name="name" 
                                                            className="form-control" 
                                                            placeholder='Enter name' />
                                                        {errors?.name &&
                                                            <p className="text-danger">{errors?.name?.message}</p>
                                                        }
                                                    </div>

                                                    <div className="col-12">
                                                        <label className="form-label">Value</label>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter value"
                                                            {...register("value", { required: "Value is required" })}
                                                        />
                                                        {errors?.value &&
                                                            <p className="text-danger">{errors?.value?.message}</p>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="text-end mt-5">
                                                        <button type="submit" className="btn btn-primary">
                                                            Create
                                                        </button>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}

export default CreateFeedbackSettings